import { ContextMenuProps } from 'app/components/ChakraTableList/ContextMenu/types';
import { useState } from 'react';
import { ContextMenuOption } from 'types/general.types';

export const useContextMenu = (passedProps?: ContextMenuProps) => {
  const [position, setPosition] = useState<{
    x: number;
    y: number;
  } | null>(null);
  const [options, setOptions] = useState<ContextMenuOption[] | null>(null);
  return {
    position,
    setPosition,
    options,
    setOptions,
    ...passedProps,
  };
};
